import { api } from '../../client';

export interface EmployeeTimeEntryDto {
  id: string;
  clocked_in_at: string;
  clocked_out_at: string | null;
  break_minutes?: number;
}

export const employeeAttendanceApi = {
  async today(): Promise<{ data?: EmployeeTimeEntryDto[]; message?: string }> {
    return api.get('/hr/attendance/today') as Promise<{ data: EmployeeTimeEntryDto[] }>;
  },

  async clockIn(): Promise<{ data?: EmployeeTimeEntryDto; message?: string }> {
    return api.post('/hr/attendance/clock-in', {}) as Promise<{ data: EmployeeTimeEntryDto; message?: string }>;
  },

  async clockOut(): Promise<{ data?: EmployeeTimeEntryDto; message?: string }> {
    return api.post('/hr/attendance/clock-out', {}) as Promise<{ data: EmployeeTimeEntryDto; message?: string }>;
  },

  async addBreakMinutes(
    minutes: number
  ): Promise<{ data?: EmployeeTimeEntryDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/hr/attendance/add-break-minutes', { minutes }) as Promise<{
      data: EmployeeTimeEntryDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },
};
